var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExp7S(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9188 3.60522C16.112 4.06653 16.0163 4.60138 15.6759 4.96264C14.4783 6.2336 11.6313 9.25491 9.76383 11.2368C9.30428 11.7245 8.6707 12 8.00872 12C7.34667 12 6.7131 11.7245 6.2536 11.2368C4.38607 9.25491 1.53914 6.2336 0.341556 4.96264C0.00115301 4.60138 -0.0945768 4.06653 0.0985834 3.60522C0.43361 2.80522 0.957518 1.55425 1.29178 0.756155C1.48389 0.297432 1.92464 0 2.41228 0H13.6051C14.0928 0 14.5335 0.297432 14.7257 0.756155C15.0599 1.55425 15.5838 2.80522 15.9188 3.60522Z",
    fill: "url(#paint0_linear_1347_33861)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0167 4.0546C16.0276 4.38582 15.9092 4.71503 15.6759 4.96267C14.4783 6.23363 11.6313 9.25493 9.76381 11.2369C9.30426 11.7245 8.67068 12 8.00869 12C7.34665 12 6.71308 11.7245 6.25357 11.2369C4.38605 9.25493 1.53912 6.23363 0.341534 4.96267C0.108162 4.71503 -0.0102247 4.38582 0.000692369 4.0546H16.0167Z",
    fill: "url(#paint1_linear_1347_33861)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1452 3.90945C12.2274 4.20379 12.2009 4.51885 12.0709 4.79455C11.5238 5.95419 9.98603 9.21398 8.96663 11.375C8.78861 11.7523 8.41535 11.992 8.00599 11.992C7.59657 11.992 7.22331 11.7523 7.04534 11.375C6.02589 9.21398 4.48812 5.95419 3.94106 4.79455C3.81099 4.51885 3.78455 4.20379 3.86673 3.90945C4.17937 2.78967 4.95821 0 4.95821 0H11.0537C11.0537 0 11.8326 2.78967 12.1452 3.90945Z",
    fill: "url(#paint2_linear_1347_33861)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1347_33861",
    x1: 8.31346,
    y1: 0,
    x2: 8.31346,
    y2: 6.23781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1347_33861",
    x1: 9.53258,
    y1: 3.11896,
    x2: 8.89442,
    y2: 11.2258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1347_33861",
    x1: 8.00599,
    y1: 1.55947,
    x2: 8.00599,
    y2: 11.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC05"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExp7S);
export default __webpack_public_path__ + "static/media/Exp-7.-S.86e7fe961694dd7236158cc6b9d27d77.svg";
export { ForwardRef as ReactComponent };